const configuredUrl = process.env.REACT_APP_BACKEND_URL || '';
const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';

function resolveBackendUrl() {
  if (!configuredUrl) return currentOrigin;
  try {
    const configHost = new URL(configuredUrl).hostname;
    const currentHost = typeof window !== 'undefined' ? window.location.hostname : '';
    if (configHost === currentHost) return configuredUrl;
  } catch {}
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host.includes('solar-green')) return currentOrigin;
    if (!configuredUrl.includes('preview.emergentagent')) return configuredUrl;
    return currentOrigin;
  }
  return configuredUrl;
}

export const BACKEND = resolveBackendUrl();
export const API = `${BACKEND}/api`;
